import { Descendant, Element } from 'slate';
import { v4 as uuidv4 } from 'uuid';

export const stripTagMarkers = (nodes: Descendant[]): Descendant[] =>
  nodes.flatMap((node): Descendant[] => {
    if (!Element.isElement(node)) return [node];
    const type = (node as { type?: string }).type;
    if (type === 'tag' || type === 'footnote') return stripTagMarkers(node.children as Descendant[]);
    const { tags: _tags, ...rest } = node as Element & { tags?: unknown; uuid?: string };
    const fresh = rest.uuid ? { ...rest, uuid: uuidv4() } : rest;
    return [{ ...fresh, children: stripTagMarkers(node.children as Descendant[]) } as Descendant];
  });
